import { useEffect, useMemo } from 'react'
import {
  DROP_DATA,
  FETCH_CATEGORIES,
} from 'modules/AccountsMarketplace/Categories/types'

import { useDispatch, useSelector } from 'react-redux'

export const useGetCategory = (categoryId) => {
  const dispatch = useDispatch()

  const { categories } = useSelector((state) => ({
    categories: state['accounts-marketplace/list'].data,
  }))

  useEffect(() => {
    dispatch({
      type: FETCH_CATEGORIES,
    })

    return () => {
      dispatch({ type: DROP_DATA })
    }
  }, [])

  const category = useMemo(
    () => categories.find(({ id }) => id === +categoryId),
    [categories, categoryId],
  )

  return {
    category,
  }
}
